import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export type ModalType = "cancel" | "confirm" | "error";

interface ModalState {
	// Modal visibility state
	showCancelModal: boolean;
	showConfirmModal: boolean;
	showErrorModal: boolean;

	// Modal content
	modalTitle: string;
	modalMessage: string;
	modalType: ModalType;
	onConfirm?: () => void;
	onCancel?: () => void;

	// Actions
	setShowCancelModal: (show: boolean) => void;
	setShowConfirmModal: (show: boolean) => void;
	setShowErrorModal: (show: boolean) => void;
	setModalContent: (
		title: string,
		message: string,
		type: ModalType,
		onConfirm?: () => void,
		onCancel?: () => void,
	) => void;
	resetModals: () => void;
}

const initialState = {
	showCancelModal: false,
	showConfirmModal: false,
	showErrorModal: false,
	modalTitle: "",
	modalMessage: "",
	modalType: "cancel" as ModalType,
	onConfirm: undefined,
	onCancel: undefined,
};

export const useModalStore = create<ModalState>()(
	devtools(
		persist(
			(set) => ({
				...initialState,

				setShowCancelModal: (show) => set({ showCancelModal: show }),

				setShowConfirmModal: (show) => set({ showConfirmModal: show }),

				setShowErrorModal: (show) => set({ showErrorModal: show }),

				setModalContent: (title, message, type, onConfirm, onCancel) =>
					set({
						modalTitle: title,
						modalMessage: message,
						modalType: type,
						onConfirm,
						onCancel,
					}),

				resetModals: () => set(initialState),
			}),
			{
				name: "modalStore",
				partialize: (state) => ({
					modalType: state.modalType,
				}),
			},
		),
	),
);
